// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66c42da6","337":"a0f0dfbc","453":"3625ab8a","667":"4fae7cfc"}[chunkId] + ".chunk.js";
};